import { Outlet } from 'react-router-dom'
import { sectionAnchors } from '../config/routes'

const NAV_ITEMS = [
  { href: sectionAnchors.features, label: 'Features' },
  { href: sectionAnchors.howItWorks, label: 'How it works' },
  { href: sectionAnchors.pricing, label: 'Pricing' },
  { href: sectionAnchors.gallery, label: 'Gallery' },
  { href: sectionAnchors.contact, label: 'Contact' },
]

// Sticky landing nav (INSPINIA #landing-navbar) + routed content + footer. The
// GateKeeper wordmark is dark text on transparent, so both nav and footer sit on
// light backgrounds to keep it legible (MVP is light-only). No customer logo/name.
export default function Layout() {
  return (
    <div className="d-flex flex-column min-vh-100 bg-body">
      <nav className="navbar navbar-expand-lg py-3 sticky-top bg-body border-bottom" id="landing-navbar">
        <div className="container">
          <a className="navbar-brand" href="#hero">
            <img src="/assets/img/logo.png" alt="Gatekeeper" height="30" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#gk-navbar"
            aria-controls="gk-navbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="gk-navbar">
            <ul className="navbar-nav fw-medium gap-2 fs-sm mx-auto mt-2 mt-lg-0">
              {NAV_ITEMS.map((item) => (
                <li className="nav-item" key={item.href}>
                  <a className="nav-link" href={item.href}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>

            <div>
              <a href={sectionAnchors.contact} className="btn btn-sm btn-primary rounded-pill">
                Get a quote
              </a>
            </div>
          </div>
        </div>
      </nav>

      <div className="flex-grow-1">
        <Outlet />
      </div>

      <footer className="border-top bg-body-tertiary py-5">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-7">
              <img src="/assets/img/logo.png" alt="Gatekeeper" height="28" />
              <p className="mt-3 mb-0 text-muted">
                RFID student ID &amp; attendance — Gatekeeper records and verifies taps, keeps parents informed by SMS,
                and helps campuses stay accountable.
              </p>
            </div>

            <div className="col-lg-5 text-lg-end">
              <p className="mb-2 fw-semibold">Proven in a live school deployment</p>
              <a href={sectionAnchors.contact} className="btn btn-primary rounded-pill">
                Get a quote
              </a>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12 text-center">
              <p className="text-muted small mb-0">© {new Date().getFullYear()} Gatekeeper</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}
